const hojdpunktenPriceCache = new Map();

function formatHojdpunktenPrice(priceInCents) {
  const amount = Number(priceInCents) / 100;
  const hasDecimals = !Number.isInteger(amount);

  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(amount);
}

async function addPriceToHojdpunktenPredictiveSearchItem(link) {
  const content = link.querySelector('.predictive-search__item-content');
  if (!content || content.querySelector('.price, .hp-predictive-price')) return;
  if (link.dataset.hpPriceStatus) return;

  link.dataset.hpPriceStatus = 'loading';

  try {
    const productUrl = new URL(link.href, window.location.origin);
    productUrl.search = '';
    productUrl.hash = '';
    const jsonUrl = `${productUrl.pathname.replace(/\/$/, '')}.js`;

    let product = hojdpunktenPriceCache.get(jsonUrl);
    if (!product) {
      const response = await fetch(jsonUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
      product = await response.json();
      hojdpunktenPriceCache.set(jsonUrl, product);
    }

    if (typeof product.price !== 'number') throw new Error('Product price is missing');

    const price = document.createElement('div');
    price.className = 'hp-predictive-price';
    price.textContent = formatHojdpunktenPrice(product.price);
    content.appendChild(price);
    link.dataset.hpPriceStatus = 'done';
  } catch (error) {
    link.dataset.hpPriceStatus = 'error';
  }
}

function updateHojdpunktenPredictiveSearchPrices(root = document) {
  const productLinks = root.querySelectorAll(
    '.predictive-search__item--link-with-thumbnail[href*="/products/"]'
  );

  productLinks.forEach((link) => addPriceToHojdpunktenPredictiveSearchItem(link));
}

function observeHojdpunktenPredictiveSearch() {
  if (window.hojdpunktenPredictiveSearchObserver || !document.body) return;

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      updateHojdpunktenPredictiveSearchPrices();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.hojdpunktenPredictiveSearchObserver = observer;
}

function initializeHojdpunktenPredictiveSearchPrices() {
  updateHojdpunktenPredictiveSearchPrices();
  observeHojdpunktenPredictiveSearch();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHojdpunktenPredictiveSearchPrices, { once: true });
} else {
  initializeHojdpunktenPredictiveSearchPrices();
}

document.addEventListener('shopify:section:load', initializeHojdpunktenPredictiveSearchPrices);
